import { UPDATABLE_STATUSES } from '@norscom/nap-shared';

export const canCancel = ['initializing', 'scheduled', 'pending', 'waiting', 'hold'];
export const canHold = ['scheduled', 'pending', 'waiting'];
export const canRelease = ['hold'];
export const canKill = ['running', 'started', 'dispatched'];

export const canDisable = ['scheduled'];
export const canRevertDisable = ['disabled'];

export const ACTIONABLE_WAIT_SUB_STATUSES = ['eventwait', 'lockwait', 'queuewait'];

export const WAITING_SUB_STATUSES = ['Console', 'EventWait', 'LockWait', 'QueueWait'];

export const canDelete = ['killed', 'canceled', 'failed', 'succeeded', 'completed', 'disabled', 'deleting'];

// Widened from the package's literal tuple, whose .includes() would refuse a plain string status.
export const canUpdate: readonly string[] = UPDATABLE_STATUSES;

export const statusOptions = [
  'scheduled',
  'pending',
  'hold',
  'waiting',
  'running',
  'completed',
  'failed',
  'canceled',
  'skipped',
  'terminated',
  'started',
  'dispatched',
  'WorkflowWait',
  'eventWait',
  'killing',
  'killed',
  'deleting',
  'disabled',
];
